import { Wordmark } from "~/web/src/brand";
import { UserMenu } from "~/web/src/user-menu";
import { VerifyBanner } from "~/web/src/verify-banner";

// The one top bar (mockup ux/06): logo, crumb, the run's status pill, account.
// No project controls live here any more — the URL is the composer's field,
// credentials arrive through the explorer's ask.

export function adminOrigin(): string | undefined {
  return (
    document.querySelector('meta[name="featurette-app-origin"]')?.getAttribute("content")?.trim() ||
    undefined
  );
}

export function Topbar({
  name,
  pill,
  omitProjectsLink,
  signinIfLoggedOut,
}: {
  /** The open project's name; absent on the list. */
  name?: string;
  pill?: { label: string; busy: boolean };
  omitProjectsLink?: boolean;
  signinIfLoggedOut?: boolean;
}) {
  // NB: this used to call navigate, but this redirect now can switch hosts, which
  // navigate cannot do; we could enable navigate to do that if we want to remove
  // a page load from these links.
  const origin = adminOrigin() || "";
  const projectsRedirect = `${origin}/projects`;
  // One grid cell of `.app` (styles.css): the banner and the bar together, however tall.
  return (
    <div class="chrome">
      <VerifyBanner />
      <header class="topbar">
        <a class="logo" href={projectsRedirect}>
          <Wordmark tone="white" />
        </a>
        {omitProjectsLink || (
          <span class="crumb">
            {name ? (
              <>
                <a href={projectsRedirect}>‹ projects / </a>
                <b>{name}</b>
              </>
            ) : (
              "projects"
            )}
          </span>
        )}
        {pill && (
          <span class={`pill ${pill.busy ? "busy" : ""}`}>
            <i />
            <span>{pill.label}</span>
          </span>
        )}
        <span class="spacer" />
        <UserMenu signinIfLoggedOut={signinIfLoggedOut} />
      </header>
    </div>
  );
}
